
import Vue from 'vue';

export default Vue.extend({
  name: 'LabelPickerInformation',
  data() {
    return {
      isOpen: false,
    };
  },
});
